import React from 'react'
import logo from '../logo.png'
import netflix from '../netflix.jpg'
import "../Nav.css"
function Nav() {
    return (
        <div className='nav'>

            <img
                className='nav_logo'
                src={netflix}
                alt="Netflix Logo"
            />
            <img
                className='my_logo'
                src={logo}
                alt="Netflix Logo"
            />
        </div>
    )
}

export default Nav